import tw, { styled } from 'twin.macro'

export const LargeHeading = styled('h1')`
  ${tw`text-5xl font-bold`}
`

export const LargeHeadingCenter = styled('h1')`
  ${tw`text-5xl font-bold text-center`}
`

export const Heading = styled('h1')`
  ${tw`text-3xl font-bold text-center my-3 sm:my-10 text-gray-800`}
`

export const HeadingSecondary = styled('h2')`
  ${tw`text-3xl font-bold text-center my-3 sm:my-10 text-gray-800`}
`

export const HeadingLeft = styled('h2')`
  ${tw`text-3xl sm:text-5xl font-bold my-4 text-gray-800`}

  a {
    ${tw`text-gray-800 hover:text-gray-900`}
  }
`

export const HeadingLeftMajor = styled('h1')`
  ${tw`text-2xl sm:text-4xl font-bold my-4 text-gray-800`}

  a {
    ${tw`text-gray-800 hover:text-gray-900`}
  }
`

export const HeadingLeftMinor = styled('h3')`
  ${tw`text-lg sm:text-xl font-bold my-2 text-gray-800`}

  a {
    ${tw`text-gray-800 hover:text-gray-900`}
  }
`

export const WhiteHeading = styled('h1')`
  ${tw`text-3xl font-bold text-center my-3 sm:my-10 text-white`}
`

export const SubHeading = styled('h3')`
  ${tw`text-xl text-center mb-2`}
`

export const SubHeadingBold = styled('h3')`
  ${tw`text-xl text-center font-bold mb-2`}
`

export const Leading = styled('p')`
  ${tw`my-4 text-gray-600 text-xl font-light`};
`

export const LeadingSmall = styled('p')`
  ${tw`my-3 text-gray-600 text-lg font-light`};
`

export const LeadingAlt = styled('h1')`
  ${tw`text-center text-gray-600 text-xl font-light`};
`

export const LeadingAltSecondary = styled('h2')`
  ${tw`text-center text-gray-600 text-xl font-light`};
`

export const PinkLeading = styled('p')`
  ${tw`text-pink-100 text-lg mx-8 lg:mx-16 mb-8 lg:max-w-3xl lg:mx-auto`}
`

export const Highlight = styled('strong')`
  ${tw`text-red-500`};
`

export const Code = styled('code')`
  ${tw`inline-block rounded-lg bg-gray-translucent text-gray-700 mr-1 mt-2 p-2 border border-solid border-gray-500`};
`

export const TagList = styled('div')`
  ${tw`flex flex-wrap mt-4`}
`

export const Tag = styled('div')`
  ${tw`bg-red-500 hover:bg-red-600 font-bold mr-3 mb-3 py-2 px-4 rounded-full`}

  a {
    ${tw`text-white no-underline`}
  }
`

export const ButtonContainer = styled('div')`
  ${tw`-mx-4`}
`

export const ContentWrapper = styled('div')`
  ${tw`prose prose-sm lg:prose-lg xl:prose-xl`}

  .deckgo-highlight-code-carbon {
      font-size: 0.875rem;
  }
`

export const ContentWrapperCenter = styled('div')`
  ${tw`prose prose-sm lg:prose-lg xl:prose-xl mx-auto bg-white p-6 rounded-lg`}

  .deckgo-highlight-code-carbon {
      font-size: 0.875rem;
  }

  .compare-table {
    ${tw`md:-ml-32 lg:-ml-40`}
  }
`

export const ContentWrapperWhite = styled('div')`
  ${tw`prose prose-sm lg:prose-lg lg:max-w-none xl:prose-xl xl:max-w-none`}

  .deckgo-highlight-code-carbon {
      font-size: 0.875rem;
  }

  h1, h2, h3, p {
    ${tw`text-white`}
  }
`

export const ContentWrapperSmall = styled('div')`
  ${tw`prose max-w-none flex-1`}
`

export const HeadingContainer = styled('div')`
  ${tw`bg-gray-50 py-4 sm:py-16`}
`

export const PricingHeadingContainer = styled('div')`
  ${tw`bg-gray-50 py-2 sm:pt-16`}
`

export const PageHeading = styled('h1')`
  ${tw`max-w-2xl mx-auto px-4 text-2xl md:text-5xl font-bold mb-4 text-center leading-snug md:leading-snug`}

  a {
    ${tw`text-red-200 hover:text-red-300`}
  }
`

export const PricingPageHeading = styled('h1')`
  ${tw`max-w-2xl mx-auto px-4 pb-4 text-2xl md:text-5xl font-bold text-center leading-snug md:leading-snug`}

  a {
    ${tw`text-red-200 hover:text-red-300`}
  }
`

export const PageSubTitle = styled('h2')`
  ${tw`max-w-2xl mx-auto px-4 text-lg md:text-2xl text-center text-gray-500 leading-relaxed md:leading-relaxed`}

  a {
    ${tw`text-red-200 hover:text-red-300`}
  }
`